export default __webpack_public_path__ + "static/Saira-Regular-3ee9f36fbbf4dce2c396bd98f54fa728.woff2";